// extracted by mini-css-extract-plugin
export var divider = "_l1-0";
export var systemMessage = "_l1-1";
export var systemMessageWrapper = "_l1-2";